import { render, staticRenderFns } from "./SearchIncomeTaxPayment.vue?vue&type=template&id=0deaf1d1&scoped=true"
import script from "./SearchIncomeTaxPayment.vue?vue&type=script&lang=js"
export * from "./SearchIncomeTaxPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deaf1d1",
  null
  
)

export default component.exports